<div class="rag-container">
    <div class="rag-content">
        <mat-card>
            <mat-card-header>
                <mat-card-title>
                    Questions & Answers Database
                    <span class="search-indicator" *ngIf="isSearchMode">
                        (Showing search results)
                    </span>
                </mat-card-title>
                <div class="header-actions">
                    <button mat-raised-button color="warn" (click)="updateTutorials()" [disabled]="isUpdating">
                        <mat-icon>update</mat-icon>
                        Update Tutorials
                    </button>
                    <button mat-raised-button color="primary" (click)="openAddDialog()">
                        <mat-icon>add</mat-icon>
                        Add New Q&A
                    </button>
                    <button mat-raised-button color="primary" [disabled]="!selectedItem" (click)="editSelected()">
                        <mat-icon>edit</mat-icon>
                        Edit
                    </button>
                    <button mat-raised-button color="primary" [disabled]="!selectedItem" (click)="deleteSelected()">
                        <mat-icon>delete</mat-icon>
                        Delete
                    </button>
                    <button mat-raised-button color="accent" *ngIf="isSearchMode" (click)="clearSearch()">
                        <mat-icon>clear</mat-icon>
                        Show All
                    </button>
                </div>
            </mat-card-header>

            <mat-card-content>
                <div class="table-container">
                    <table mat-table [dataSource]="dataSource" matSort class="qa-table">

                        <!-- ID Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                        </ng-container>

                        <!-- Question Column -->
                        <ng-container matColumnDef="question">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Question </th>
                            <td mat-cell *matCellDef="let element" class="question-cell">
                                <div class="question-text">{{element.question}}</div>
                            </td>
                        </ng-container>

                        <!-- Answer Column -->
                        <ng-container matColumnDef="answer">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Answer </th>
                            <td mat-cell *matCellDef="let element" class="answer-cell">
                                <div class="answer-text">{{element.answer}}</div>
                            </td>
                        </ng-container>

                        <!-- Category Column -->
                        <ng-container matColumnDef="category">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Category </th>
                            <td mat-cell *matCellDef="let element">
                                <span class="category-badge">{{element.category}}</span>
                            </td>
                        </ng-container>


                        <!-- Video ID Column -->
                        <ng-container matColumnDef="videoId">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Video ID </th>
                            <td mat-cell *matCellDef="let element">
                                <span class="video-badge clickable" 
                                      *ngIf="element.videoId"
                                      (click)="onVideoIdClick(element.videoId); $event.stopPropagation()">
                                    {{element.videoId}}
                                </span>
                                <span class="video-badge" *ngIf="!element.videoId">-</span>
                            </td>
                        </ng-container>

                        <!-- Similarity Column (only shown in search mode) -->
                        <ng-container matColumnDef="similarity">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Similarity </th>
                            <td mat-cell *matCellDef="let element">
                                <span class="similarity-badge" [class.high-similarity]="element.similarity >= 0.8"
                                      [class.medium-similarity]="element.similarity >= 0.6 && element.similarity < 0.8"
                                      [class.low-similarity]="element.similarity < 0.6">
                                    {{element.similarity ? (element.similarity * 100).toFixed(1) + '%' : '-'}}
                                </span>
                            </td>
                        </ng-container>

                        <!-- Created Date Column -->
                        <ng-container matColumnDef="createdDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Created </th>
                            <td mat-cell *matCellDef="let element"> {{element.createdDate | date:'short'}} </td>
                        </ng-container>


                        <tr mat-header-row *matHeaderRowDef="currentColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: currentColumns;"
                            (click)="selectRow(row)"
                            [class.selected-row]="isRowSelected(row)"
                            class="clickable-row"></tr>

                        <!-- Row shown when there is no matching data -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="6">No data matching the filter "{{dataSource.filter}}"</td>
                        </tr>
                    </table>
                </div>
            </mat-card-content>
        </mat-card>
        
        <div class="spacer"></div>
        
        <mat-card class="prompt-card">
            <mat-card-content>
                <div class="prompt-container">
                    <mat-form-field class="prompt-input" appearance="outline">
                        <textarea matInput 
                                  [(ngModel)]="searchQuery"
                                  placeholder="Type your question here..."
                                  rows="1"
                                  cdkTextareaAutosize
                                  cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="5"
                                  (keydown.enter)="$event.preventDefault(); searchSimilar()"></textarea>
                    </mat-form-field>
                    <div class="limit-dropdown">
                        <mat-select [(ngModel)]="searchLimit" class="limit-select">
                            <mat-option *ngFor="let limit of limitOptions" [value]="limit">
                                {{limit}}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="threshold-dropdown">
                        <mat-select [(ngModel)]="searchThreshold" class="threshold-select">
                            <mat-option *ngFor="let threshold of thresholdOptions" [value]="threshold.value">
                                {{threshold.label}}
                            </mat-option>
                        </mat-select>
                    </div>
                    <button mat-fab color="primary" class="send-button" (click)="searchSimilar()">
                        <mat-icon>send</mat-icon>
                    </button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
